import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { DialogProps } from "./useDialogs";

export interface ConfigValidationRuleTypeDialogProps {
  addLLMQuery: Function;
  addJsonataQuery: Function;
}

const ConfigValidationRuleTypeDialog = ({
  payload,
  open,
  onClose,
}: DialogProps<ConfigValidationRuleTypeDialogProps>) => {
  const handleQueryClick = (value: string) => {
    if (value === "LLM") {
      payload.addLLMQuery();
    } else if (value === "Formule") {
      payload.addJsonataQuery();
    }
    onClose();
  };

  return (
    <Dialog onClose={() => onClose()} open={open}>
      <DialogTitle>Choisissez un type de validation</DialogTitle>
      <DialogContent>
        <List>
          {Object.values(["LLM", "Formule"]).map((type) => (
            <ListItem disablePadding key={type}>
              <ListItemButton onClick={() => handleQueryClick(type)}>
                <ListItemText primary={type} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigValidationRuleTypeDialog;
